// Deliberately scoped to this page, not sessionStorage (duplicated tabs copy it).
let pageId: string;
export function participantIdentity(name: string) {
	if (!pageId) {
		const bytes = crypto.getRandomValues(new Uint8Array(16));
		bytes[6] = (bytes[6] & 15) | 64;
		bytes[8] = (bytes[8] & 63) | 128;
		const hex = Array.from(bytes, (b) =>
			b.toString(16).padStart(2, '0'),
		).join('');
		pageId = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
	}
	const identity = `${name.trim()}~vc1~${pageId}`;
	if (!name.trim() || new Blob([identity]).size > 128) {
		throw new Error('Please enter a shorter name to join the call.');
	}
	return identity;
}
export function participantName(identity: string) {
	return identity.replace(
		/~vc1~[a-f\d]{8}-[a-f\d]{4}-4[a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12}$/i,
		'',
	);
}
